export default {
  en: {
    Home: {
      record: 'Record',
      singlePlayer: 'Single Player',
      about: 'ABOUT',
      aboutDescription: 'Geoguess Master is a free and lazy geoguess game with no ads. \
        Players compete how close the player can guess random locations in five rounds. \
        You can share the score with other people via social media like Facebook or Twitter. \
        You can play multiplayer game with your friends up to five friends. \
        The first player creates a room and decide the room size. Other players type the same room name as the first player created and the game will start. ',
      limitation: 'LIMITATION',
      limitationDescription: "Currently I set quotas per day so the cost to run this game can't get too high. \
        If the map doesn't load, it means the quotas has been exceeded on the day. \
        It will reset at midnight Pacific Time. Sorry for inconvenience. \
        This game is open source so you can build your own game server and play this game unlimitedly.",
    },
    StreetViewWithFriends: {
      waitForOtherPlayers: 'Waiting for other players...',
      redirectToHomePage: 'Redirect to Home Page...',
      exitGame: 'You are forced to exit the game. Redirect to home page after 5 seconds...',
      waitForOtherPlayersToFinish: 'Waiting for other players to finish the game...',
    },
    Maps: {
      makeGuess: 'MAKE GUESS',
      guess: 'GUESS',
      nextRound: 'NEXT ROUND',
      viewSummary: 'VIEW SUMMARY',
    },
    MapsWithFriends: {
      makeGuess: 'MAKE GUESS',
      guess: 'GUESS',
      nextRound: 'NEXT ROUND',
      viewSummary: 'VIEW SUMMARY',
    },
    Header: {
      language: 'Language',
      about: 'About',
      limitation: 'Limitation',
      contact: 'Contact',
    },
    HeaderGame: {
      round: 'ROUND',
      score: 'SCORE',
    },
    CardRoomName: {
      title: 'Type a room name.',
      next: 'NEXT',
      cancel: 'CANCEL',
    },
    CardRoomPlayerName: {
      title: 'Type a player name.',
      next: 'NEXT',
      cancel: 'CANCEL',
    },
    CardRoomSize: {
      title: 'Set a room size.',
      next: 'NEXT',
      cancel: 'CANCEL',
    },
    CardRoomTime: {
      title: 'Set a time limitation.',
      next: 'NEXT',
      cancel: 'CANCEL',
      infinite: 'Infinite',
    },
    CardRoomTopic: {
      title: 'Set a custom topic.',
      next: 'NEXT',
      cancel: 'CANCEL',
      random: 'Random',
      custom: 'Custom',
      customPlaceholder: 'Type your custom topic here (starting your text with "places in " is recommended)',
      poiWorld: 'Points of interest in World',
      poiEurope: 'Points of interest in Europe',
      poiUSA: 'Points of interest in USA',
      poiRussia: 'Points of interest in Russia',
      poiAsia: 'Points of interest in Asia',
      poiAustralia: 'Points of interest in Australia',
      castlesEurope: 'Castles in Europe',
    },
    DialogRoom: {
      withFriends: 'With Friends',
      invalidRoomName: 'Invalid name. Please try another.',
      inProgress: 'The first player is creating the room right now. Please wait and try again.',
      roomIsFull: 'This room is already full. Please try another.',
    },
    DialogSummary: {
      exit: 'EXIT',
      playAgain: 'PLAY AGAIN',
    },
    DialogSummaryWithFriends: {
      exit: 'EXIT',
    },
    Footer: {
      privacyPolicy: 'Privacy Policy',
    },
  }
}